<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ຫນ້າ Department of Agri Product Sale and Marketing - {{ROLEID}}
            
          </h2>
        </div>
      </div>
      <div class="no-print">
        <div class="columns ">
          <div class="column">
            <b-field label="">
              <vue-monthly-picker inputClass="input" v-model="selectedMonth">
              </vue-monthly-picker>
            </b-field>
          </div>
          <!-- <div class="column">
            <div class="columns">
              <div class="column">
                <b-field grouped>
                  <b-field class="">
                    <button class="button is-primary" @click="loadFormsByMonth">
                      ດືງຂໍ້ມູນຕາມເດືອນ
                    </button>
                  </b-field>
                  <b-field class="">
                    <button class="button is-primary" @click="loadForms">
                      ດືງຂໍ້ມູນທັງໝົດ
                    </button>
                  </b-field>

                  <b-field class="">
                    <button class="button is-primary">
                      <router-link
                        class="content-link"
                        :to="{
                          name: 'debtSummaryDailyProjectsReport',
                          params: {
                            MONTH: currentmonthsend
                          }
                        }"
                        style="color:white"
                      >
                        ລາຍງານສະຫຼຸບ
                      </router-link>
                    </button>
                  </b-field>

                  <b-field class="">
                    <button class="button is-info" @click="print">
                      ພິມ
                    </button>
                  </b-field>
                </b-field>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <div v-show="datatable" class="scrollme">
        <table class="table is-fullwidth is-bordered">
          <thead>
            <tr>
              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="2%"
              >
                #
              </th>
              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="13%"
              >
                ສະໜາມ
              </th>
              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="8%"
              >
                ຜູ້ສະໜອງ
              </th>
              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="8%"
              >
                ວັນທີ
              </th>

              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="8%"
              >
                ເລກບິນ
              </th>
              <th
                class="has-text-centered vertical-middle"
                rowspan="2"
                width="10%"
              >
                ລາຍການ
              </th>
              <th class="has-text-centered" colspan="3">ໜີ້</th>
              <th class="has-text-centered" colspan="3">ຊຳລະ</th>
              <th class="has-text-centered vertical-middle" rowspan="2">
                ໝາຍເຫດ
              </th>
            </tr>
            <tr>
              <th class="has-text-centered">ກີບ</th>
              <th class="has-text-centered">ບາດ</th>
              <th class="has-text-centered">ໂດລາ</th>
              <th class="has-text-centered">ກີບ</th>
              <th class="has-text-centered">ບາດ</th>
              <th class="has-text-centered">ໂດລາ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(dataform, index) in dataforms"
              :key="dataform.EXPENSEID"
            >
              <td class="has-text-centered">{{ index + 1 }}</td>
              <td>
                  {{ dataform.projectname }}
              </td>
              <td>{{ dataform.supplliername }}</td>
              <td class="has-text-centered">
                {{ dataform.TXDATE }}
              </td>
              <td>
                {{ dataform.billnumber }}
              </td>
              <td>
                {{ dataform.description }}
              </td>
              <td class="has-text-right">
                {{ dataform.LAK | formatNumberLocal }}
              </td>
              <td class="has-text-right">
                {{ dataform.THB | formatNumberLocal }}
              </td>
              <td class="has-text-right">
                {{ dataform.USD | formatNumberLocal }}
              </td>
              <td class="has-text-right">
                {{ dataform.PLAK | formatNumberLocal }}
              </td>
              <td class="has-text-right">
                {{ dataform.PTHB | formatNumberLocal }}
              </td>
              <td class="has-text-right">
                {{ dataform.PUSD | formatNumberLocal }}
              </td>
              <td class="has-text-right"></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="6" class="has-text-centered">
                ລວມ {{ dataforms.length | formatNumberLocal }} ລາຍການ
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["LAK"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["THB"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["USD"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["PLAK"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["PTHB"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right">
                {{ _.sumBy(dataforms, i => i["PUSD"] * 1) | formatNumberLocal }}
              </th>
              <th class="has-text-right"></th>
            </tr>
          </tfoot>
        </table>
      </div> -->
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  components: { VueMonthlyPicker },
  props: ["MONTH"],
  data() {
    return {
      datatable: false,
      dataforms: [],
      selectedMonth: this.MONTH ? this.MONTH : moment(),
      loadall: 0
    };
  },
  methods: {
    loadForms() {
      this.resetData();
      this.loadall = 1;
      this.datatable = true;
      this.currentmonthshow = "ທັງໝົດ";
      RestAPI.debtDailyProjectsReport()
        .then(res => {
          this.dataforms = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    loadFormsByMonth() {
      this.resetData();
      this.loadall = 0;
      this.datatable = true;
      RestAPI.debtDailyProjectsReportByMonth(this.currentmonthsend)
        .then(res => {
          this.dataforms = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    resetData() {
      this.datatable = false;
      this.dataforms = "";
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    // this.loadFormsByMonth();
  },
  computed: {
    currentmonthsend() {
      return new moment(this.selectedMonth).format("YYYY-MM");
    },
    currentmonthshow() {
      return "ເດືອນ " + new moment(this.selectedMonth).format("MM/YYYY");
    }
  }
};
</script>
